import { useEffect, useRef } from 'react';
import { EngineOptions } from '@babylonjs/core/Engines/thinEngine';
import { Scene, SceneOptions } from '@babylonjs/core/scene';
import { Engine } from '@babylonjs/core/Engines/engine';
import { Inspector } from '@babylonjs/inspector';
import { LightHelper } from '../util/LightHelper';
import { SpriteHelper } from '../util/SpriteHelper';
import { HoverHelper } from '../util/HoverHelper';

type SceneProps = {
  antialias?: boolean;
  engineOptions?: EngineOptions;
  adaptToDeviceRatio?: boolean;
  sceneOptions?: SceneOptions;
  onRender?: (scene: Scene) => void;
  onSceneReady: (scene: Scene) => void;
}

function SceneComponent(props: SceneProps, { ...rest }) {

  const reactCanvas = useRef(null)

  useEffect(() => {


    const { antialias, engineOptions, adaptToDeviceRatio, sceneOptions, onRender, onSceneReady } = props
    const { current: canvas } = reactCanvas;

    if (!canvas) return;

    // Create Scene and Engine
    const engine = new Engine(canvas, antialias, engineOptions, adaptToDeviceRatio)
    const scene = new Scene(engine, sceneOptions)

    // Start Ready-Hook when scene is ready
    if (scene.isReady()) {
      onSceneReady(scene)
    } else {
      scene.onReadyObservable.addOnce((scene) => onSceneReady(scene))
    }

    // run render loop if existent
    engine.runRenderLoop(() => {
      if (typeof onRender === 'function') onRender(scene)
      scene.render()
    })

    const resize = () => {
      scene.getEngine().resize()
    }

    if (window) {
      window.addEventListener('resize', resize);
      document.body.addEventListener('keyup', (e) => {
        if (e.code === 'KeyI')
          Inspector.Show(scene, { embedMode: false, globalRoot: document.body, overlay: true })
      })
    }

    return () => {
      LightHelper.CleanupLights();
      SpriteHelper.CleanupHotspots();
      HoverHelper.CleanupHoverList();
      scene.getEngine().dispose();
      if (window) {
        window.removeEventListener('resize', resize);
        document.body.removeEventListener('keyup', (e) => {
          if (e.code === 'KeyI')
            Inspector.Show(scene, { embedMode: false, globalRoot: document.body, overlay: true })
        })
      }
    }

  }, [props]);

  return (
    <canvas id='render-canvas' ref={reactCanvas} {...rest} width={1920} height={1080} />
  )
}

export default SceneComponent